<template>
  <div class="h-auto ml-0 w-full lg:mr-3 mt-2 p-3 pt-0">
    <el-tabs type="border-card">
      <el-tab-pane
        v-for="(tab, index) in tabs"
        :key="index"
        :label="tab.name"
        @click="(e) => setTab(e, tab.name)"
      >
        <AssetTypesList v-if="index == 0"></AssetTypesList>
        <AssetStatusList v-if="index == 1"></AssetStatusList>
        <AssetBrandList v-if="index == 2"></AssetBrandList>
        <AssetModelList v-if="index == 3"></AssetModelList>
        <AssetConditionList v-if="index == 4"></AssetConditionList>
        <AssetsList v-if="index == 5"></AssetsList>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
// Other setups
import AssetsList from "@/components/CompanySetups/assetsSetups/assetsList.vue";
import AssetTypesList from "./assetsSetups/assetTypes/assetTypesList.vue";
import AssetStatusList from "./assetsSetups/assetStatus/assetStatusList.vue";
import AssetConditionList from "./assetsSetups/assetConditions/assetConditionList.vue";
import AssetBrandList from "./assetsSetups/assetBrands/assetBrandList.vue";
import AssetModelList from "./assetsSetups/assetModels/assetModelList.vue";

export default {
  name: "SetupsTabs",
  props: ["setup"],
  components: {
    AssetsList,
    AssetTypesList,
    AssetStatusList,
    AssetConditionList,
    AssetBrandList,
    AssetModelList,
  },
  data() {
    return {
      selectedTab: "Assets",
      teamKey: 0,
      mineKey: 1,
      isApproved: true,
      isDeclined: false,
      tabs: [
        {
          name: "Asset Types",
          route: "assets-types",
        },
        {
          name: "Asset Status",
          route: "assets-status",
        },
        {
          name: "Asset Brands",
          route: "assets-brands",
        },
        {
          name: "Asset Models",
          route: "assets-models",
        },
        {
          name: "Asset Conditions",
          route: "assets-condition",
        },
        {
          name: "Assets",
          route: "assets",
        },
      ],
    };
  },
  created() {},
  methods: {
    close() {
      this.$emit("close");
    },

    setTab(event, newTab) {
      this.selectedTab = newTab.trim();
      this.updateLeaveList(this.selectedTab);
      switch (newTab) {
        case "Approved":
          break;
        case "Pending":
          break;
      }
    },
  },
  watch: {},
};
</script>
<style>
.el-tabs--border-card > .el-tabs__content {
  padding: 0;
}
</style>
